import { Box, useClipboard } from '@chakra-ui/react';
import { Button, type ButtonProps } from '@time-line/components/common';
import { Check, Copy } from '@time-line/components/icons';
import { useAnalytics } from 'hooks/useAnalytics';

interface CopyPromoCodeButtonProps extends ButtonProps {
  code: string;
  productTitle: string;
}

export function CopyPromoCodeButton({
  children,
  onClick,
  code,
  productTitle,
  ...props
}: CopyPromoCodeButtonProps) {
  const { analytics } = useAnalytics();
  const { hasCopied, onCopy } = useClipboard(code);

  return (
    <Button
      className="button--copy-promo-code"
      variant="dashed"
      leftIcon={<Box />}
      rightIcon={hasCopied ? <Check /> : <Copy />}
      color="green.600"
      bgColor="greenAlpha.250"
      fontSize="sm"
      fontFamily="body"
      letterSpacing="0.08px"
      pr="2xs"
      _hover={{
        bgColor: 'greenAlpha.400',
      }}
      _active={{
        bgColor: 'greenAlpha.400',
      }}
      onClick={() => {
        onCopy();
        analytics.selectPromotion({ code, product: { name: productTitle } });
      }}
      {...props}
    >
      {hasCopied ? 'Code copied' : code}
    </Button>
  );
}
